
export const globalConf = {

  url_api_presencia: "https://servicio.ampresencia.com/",
  // url_api_presencia : "https://servicio-beta.ampresencia.com/",

  path_Token: "token",
  path_Login_listadoEmpresas: "api/alo/empresas/",
  //path_documetosRetoTokenEmpresa : "api/empresas/tokenempresa/fitosanitarios/DocumentosReto",
  path_documetosRetoTokenEmpresa: "/api/fitosanitarios/TransaccionesDocumentosRETO/",
  path_documentosRetoCrecenciaAlo: 'api/fitosanitarios/DocumentosRETO',
  path_credeciales_RETO: 'api/fitosanitarios/loginreto/',
  path_AlmacenesRopo: 'api/fitosanitarios/AlmacenesRETO',

  path_Carga_Usuarios: "api/Administracion/CargaUsuarios/ID_Empresa ",
  path_administracion_version: "/Administracion/VersionApp/",
  path_account_resetPassword: "/api/Account/ResetPassword",
  path_account_confirmReset: "/api/Account/ConfirmReset",

  // FIREBASE FUNCTIONS
  path_firebaseFunctions: "https://europe-west1-alo-fitosanitarios-reto.cloudfunctions.net",
  //path_firebaseFunctions: "http://localhost:5001/alo-fitosanitarios-reto/europe-west1",
  path_path_firebaseFunctions_credenciales: "/credenciales",
  path_path_firebaseFunctions_soapReto: "/reto",

  path_v2_documentosTransacciones: '/api/v2/documentostransacciones/',

  //autorization              : "Basic cmVzdF9wcmVzZW5jaWFAYW1zeXN0ZW0uZXM6QU1TWVNURU0=",
  authorization: 'Basic ZGNvcnRlc0BhbXN5c3RlbS5lczpwZG0xOTEy',

  app_version: '3.1.3',

  url_google_maps_api_geocode: 'https://maps.googleapis.com/maps/api/geocode/json',
  api_key_google_browser: 'AIzaSyAwIyX9pL25zOPNOV52gG76SbTAEz6sbKg',
  api_key_google_android: 'AIzaSyCPdG5rBrUREEn6am-OEV9ihBaGykOsccI',
  api_key_google_ios: 'AIzaSyDXKmeMCIno0IsDfTQfBnY9ANcIZm8CIYE',
  api_key_google_server: 'AIzaSyDPPISZ9oNuVZ7BvtC2g7fswPLfodHh0zE',

  estados: [
    {
      value: 0,
      text: 'Todos'
    },
    {
      value: 1,
      text: 'Nuevos'
    },
    {
      value: 2,
      text: 'Modificados'
    }
  ],



  tipoDocumento: [
    {
      value: 999,
      text: 'Todos'
    },
    {
      value: 0,
      text: 'Facturas ALO'
    },
    {
      value: 2,
      text: 'Albaranes ALO'
    },
    {
      value: 8,
      text: 'Traspasos de Almacén'
    },
    {
      value: 100,
      text: 'Facturas de externos'
    },
    {
      value: 102,
      text: 'Albaranes de externos'
    },
    {
      value: 108,
      text: 'Traspasos de almacén externos'
    },
    {
      value: 20,
      text: 'Albaranes ALO positivos'
    }
    ,
    {
      value: 21,
      text: 'Albaranes ALO negativos'
    },
    {
      value: 10,
      text: 'Facturas ALO positivas'
    },
    {
      value: 11,
      text: 'Facturas ALO negativas'
    },
    {
      value: 80,
      text: 'Traspasos de Almacén (salida)'
    },
    {
      value: 81,
      text: 'Traspasos de Almacén (entrada)'
    }
  ],

  codigoOperacion: [
    {
      value: 999,
      text: 'Todos'
    },
    {
      value: 1,
      text: 'Compra en España'
    },
    {
      value: 2,
      text: 'Venta en España'
    },
    {
      value: 3,
      text: 'Importación UE'
    },
    {
      value: 4,
      text: 'Importación no UE'
    },
    {
      value: 5,
      text: 'Exportación UE'
    },
    {
      value: 6,
      text: 'Exportación no UE'
    },
    {
      value: 7,
      text: 'Adquisición tratamientos'
    },
    {
      value: 8,
      text: 'Aplicación tratamientos'
    },
    {
      value: 11,
      text: 'Compra en España Entrada'
    },
    {
      value: 12,
      text: 'Compra en España Salida'
    },
  ],
  unidadesMedida: [
    {
      value: 1,
      text: 'gramos (gr)'
    },
    {
      value: 2,
      text: 'kilogramos (Kg)'
    },
    {
      value: 3,
      text: 'litros (L)'
    },
    {
      value: 4,
      text: 'miligramos/unidades (mg/ud)'
    },
    {
      value: 5,
      text: 'mililitros (ml)'
    },
  ],


}

export enum codigosErrorRETO {
  A0001 = 'El Tipo es obligatorio',
  A0002 = 'La fecha de transacción es obligatorio',
  A0003 = 'El NIF del responsable es obligatorio',
  A0004 = 'El código ROPO del responsable es obligatorio',
  A0005 = 'El código de operación es obligatorio',
  A0006 = 'El NIF del destinatario es obligatorio',
  A0007 = 'El código ROPO del destinatario es obligatorio',
  A0008 = 'La entidad del destinatario es obligatoria',
  A0009 = 'El correo electrónico telefono o fax del destinatario es obligatoria',
  A0010 = 'La dirección del destinatario es obligatoria',
  A0011 = 'El código postal del destinatario es obligatorio',
  A0012 = 'El país del destinatario es obligatorio',
  A0013 = 'La provincia del destinatario es obligatorio',
  A0014 = 'La localidad del destinatario es obligatorio',
  A0015 = 'El NIF de la persona autorizada es obligatorio',
  A0016 = 'El Nombre de la persona autorizada es obligatorio',
  A0017 = 'El primer apellido de la persona autorizada es obligatorio',
  A0018 = 'El número de registro del producto es obligatorio',
  A0019 = 'El nombre comercial del producto es obligatorio',
  A0020 = 'El lote del producto es obligatorio',
  A0021 = 'El volumen total o la capacidad y el número de envases del producto es obligatorio',
  A0022 = 'El codigo de unidad del producto es obligatorio',
  A0023 = 'El objeto de tratamiento o cultivo del producto es obligatorio',
  A0024 = 'La capacidad es obligatoria si el número de envases viene informado',
  A0025 = 'El número de envases es obligatorio si la capacidad viene informada',
  B0001 = 'El tipo no es correcto',
  B0002 = 'El NIF del responsable no es correcto',
  B0003 = 'La fecha de transacción no es correcta',
  B0004 = 'El código ROPO del responsable no es correcto',
  B0005 = 'El código de operación no es correcto',
  B0006 = 'El NIF del destinatario no es correcto',
  B0007 = 'El código ROPO del destinatario no es correcto',
  B0008 = 'El correo electrónico del destinatario no es correcto',
  B0009 = 'El país del destinatario no es correcto',
  B0010 = 'La provincia del destinatario no es correcta',
  B0011 = 'La localidad del destinatario no es correcta',
  B0012 = 'El NIF de la persona autorizada no es correcto',
  B0013 = 'El número de registro del producto no es correcto',
  B0014 = 'El codigo de unidad del producto no es correcto',
  B0015 = 'La denominación común del producto no es correcta',
  B0016 = 'La importación paralela del producto no es correcta',
  B0017 = 'La capacidad del producto no es correcta',
  B0018 = 'El número de envases del producto no es correcto',
  B0019 = 'El volumen total del producto no es correcto',
  B0020 = 'El tipo operación 1 (Compra en España) ya es admitido',
  B0021 = 'El código de operación de origen no es correcto',
  B0022 = 'El volumen es demasiado grande',
  C0001 = 'El NIF del responsable no corresponde con el código ROPO indicado',
  C0002 = 'La fecha indicada supera la fecha máxima para introducir la transacción',
  C0003 = 'El usuario no tiene permiso para operar con la entidad responsable',
  C0004 = 'El NIF del destinatario no corresponde con el código ROPO indicado',
  C0005 = 'El código de operación indicado no es válido para el código ROPO del responsable proporcionado',
  C0006 = 'El código de operación indicado no es válido para el código ROPO del destinatario proporcionado',
  C0007 = 'La fecha indicada no es válida para el código ROPO del responsable proporcionado',
  C0008 = 'La fecha indicada no es válida para el código ROPO del destinatario proporcionado',
  C0009 = 'No se ha encontrado el producto',
  C0010 = 'Error al buscar el producto a validar',
  C0011 = 'El volumen total de devoluciones excede del servido',
  C0012 = 'Error al recuperar la transacción origen',
  C0013 = 'El código de la operación recuperada no coincide con el facilitado',
  C0014 = 'El código ropo origen es distinto al código ropo origen de la operación originaria de la devolución',
  C0015 = 'El código ropo destino es distinto al código ropo destino de la operación originaria de la devolución ',
  C0016 = 'La transacción no puede ser modificada ya que tiene una devolución asociada',
  C0017 = 'El NIF origen es distinto al NIF origen de la operación originaria de la devolución',
  C0018 = 'El NIF destino es distinto al NIF destino de la operación originaria de la devolución',
  C0019 = 'El número de registro de producto fitosanitario no se ha encontrado en Aspafitos',
  C0020 = 'El nombre del producto fitosanitario no coincide con el facilitado por Aspafitos',
  C0021 = 'El número de registro de producto fitosanitario no se encuentra vigente en Aspafitos para la fecha indicada',
  C0022 = 'Error recuperando datos del producto fitosanitario',
  C0023 = 'El número de registro de producto fitosanitario no tiene o ya ha finalizado su periodo de gracia',
}